import { useEffect } from '../lib/teact/teact'
import * as langProvider from '../util/langProvider'
import useForceUpdate from './useForceUpdate'

export type LangFn = langProvider.LangFn

const useLang = (): LangFn => {
  const forceUpdate = useForceUpdate()

  useEffect(() => {
    return langProvider.addCallback(forceUpdate)
  }, [forceUpdate])

  return langProvider.getTranslationFn()
}

export default useLang
